import { __decorate } from "tslib";
// import { BootstrapVue } from "bootstrap-vue";
import { Options, Vue } from "vue-class-component";
// Page Sections
import Certifications from "@/components/sections/Certifications.vue";
import Testimonials from "@/components/sections/Testimonials.vue";
import AboutUs from "@/components/sections/AboutUs.vue";
import MySkillsSect from "@/components/sections/MySkillsSect.vue";
import WhatICanDo from "@/components/sections/WhatICanDo.vue";
import PortfolioComp from "@/components/PortfolioComp.vue";
let Work = class Work extends Vue {
};
Work = __decorate([
    Options({
        components: {
            Certifications,
            AboutUs,
            Testimonials,
            MySkillsSect,
            WhatICanDo,
            PortfolioComp,
        },
        data() {
            return {};
        },
        created: () => {
            console.log(" home created ");
        },
        mounted() {
            console.log(" home mounted ");
            // this.$store.dispatch("getSiteData");
        },
        computed: {
            site_data() {
                return this.$store.state.site_data;
            },
            // async site_data2() {
            // 	return await this.$store.state.site_data;
            // },
            // async site_data4() {
            // 	try {
            // 		const res = await this.$store.state.site_data;
            // 		return res;
            // 	} catch (err) {
            // 		throw new Error(`Problem handling something: ${err}.`);
            // 	}
            // },
        },
    })
], Work);
export default Work;
